import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const REPORT_URLS: generalConst = {
  BASE_URL: ROUTES.REPORT,
  REPORT_DETAIL: `${ROUTES.REPORT}/detail`,
};

export interface IReportProps {
  resetState: () => {};
}

export const STATE_IDENTIFIER = {
  REPORTS: "reports",

  REPORTS_LOADER: "reportsLoader",

  SELECTED_REPORT: "selectedReport",

  RESPONSE_STATE: "ResponseState",

  REPORT_PARAMETERS: "ReportParameters",

  VALUE: "Value",

  CAMPAIGN_NAMES: "campaignNames",

  CALL_STATE: "callState",
};
